import React, { useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import links from '../data/site-structure';
import { ActionsIcon } from './actions-icon';
import { StyledToolsLink, StyledLoginButton, StyledLoginLinkButton } from '../header.styled';
import { Link } from '@at/design-system-elements';
import { TypeFiesta } from '@at/design-system-foundation';
import { StyledActionContent, StyledActionIcon, StyledActionTitle, StyledActionTitleContainer, StyledActionTitleIcon, StyledActionTitleText, } from './actions.styled';
var testIdSignIn = 'account-sign-in';
var testIdSignOut = 'account-sign-out';
var LoginAction = function (_a) {
    var isNarrow = _a.isNarrow, userSignedIn = _a.userSignedIn, signedIn = _a.signedIn, signedOut = _a.signedOut, _b = _a.useNewSignIn, useNewSignIn = _b === void 0 ? false : _b, setShowSignInModal = _a.setShowSignInModal, trackingCallback = _a.trackingCallback;
    var _c = useState(false), showSubNav = _c[0], setShowSubNav = _c[1];
    var handleCloseSubmenu = function (e) {
        if (e.key === 'Escape' && showSubNav)
            setShowSubNav(false);
    };
    var handleMouseEnter = function () {
        if (!showSubNav)
            setShowSubNav(true);
    };
    var handleMouseLeave = function () {
        if (showSubNav)
            setShowSubNav(false);
        // @ts-ignore
        document.activeElement.blur();
    };
    return (React.createElement(React.Fragment, null,
        userSignedIn && isNarrow && (React.createElement(StyledLoginButton, { routerLink: false, href: signedIn.url, trackingCallback: trackingCallback, "data-testid": testIdSignOut },
            React.createElement(ActionsIcon, { name: "account" }),
            " ",
            signedIn.text)),
        userSignedIn && !isNarrow && (React.createElement(StyledLoginButton, { narrowHide: true, href: signedIn.url, trackingCallback: trackingCallback, onKeyDown: handleCloseSubmenu, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, "data-testid": testIdSignOut },
            React.createElement(ActionsIcon, { name: "account" }),
            " ",
            signedIn.text)),
        !userSignedIn && (React.createElement(StyledActionContent, null,
            React.createElement(StyledActionTitleContainer, null,
                React.createElement(StyledActionTitleIcon, null,
                    React.createElement(StyledActionIcon, { svgContent: React.createElement("path", { d: "m12.02 10.22c-.99 0-1.8-.81-1.8-1.8s.81-1.8 1.8-1.8 1.8.81 1.8 1.8-.81 1.8-1.8 1.8zm0-5.4c-1.99 0-3.6 1.61-3.6 3.6s1.61 3.6 3.6 3.6 3.6-1.61 3.6-3.6-1.61-3.6-3.6-3.6zm6.59 13.3c-1.11-2.53-3.64-4.31-6.59-4.31s-5.48 1.77-6.59 4.31c-1.49-1.61-2.41-3.75-2.41-6.11 0-3.47 1.94-6.57 5.06-8.09 1.23-.6 2.55-.9 3.94-.9 4.96 0 9 4.04 9 9 0 2.36-.92 4.5-2.41 6.11zm-6.59 2.9c-1.91 0-3.69-.61-5.15-1.63.69-2.18 2.74-3.77 5.15-3.77s4.45 1.59 5.15 3.77c-1.46 1.02-3.23 1.63-5.15 1.63zm0-19.8c-1.69 0-3.3.39-4.72 1.09-3.6 1.75-6.08 5.44-6.08 9.71 0 3.22 1.42 6.11 3.66 8.09.54.48 1.13.9 1.75 1.26 1.59.91 3.42 1.45 5.38 1.45s3.79-.53 5.38-1.45c.63-.36 1.21-.79 1.75-1.26 2.24-1.98 3.66-4.87 3.66-8.09 0-5.96-4.83-10.8-10.8-10.8h.02z" }), width: "24", height: "24", title: "" })),
                React.createElement(StyledActionTitle, null,
                    React.createElement(StyledActionTitleText, { weight: "500" }, "Sign in"),
                    React.createElement(TypeFiesta, null, "Save vehicles, searches and create alerts for price drops and new listings by signing in"))),
            !useNewSignIn ? (React.createElement(StyledLoginLinkButton, { href: signedOut.url, routerLink: false, trackingCallback: trackingCallback, "data-testid": testIdSignIn }, signedOut.text)) : (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            React.createElement(StyledLoginLinkButton, { as: "button", onClick: function (event) {
                    event.preventDefault();
                    trackingCallback === null || trackingCallback === void 0 ? void 0 : trackingCallback();
                    if (setShowSignInModal)
                        setShowSignInModal(true);
                }, "data-testid": testIdSignIn }, signedOut.text))))));
};
export var Actions = function (_a) {
    var _b = _a.show, show = _b === void 0 ? true : _b, _c = _a.userSignedIn, userSignedIn = _c === void 0 ? false : _c, isNarrow = _a.isNarrow, _d = _a.useNewSignIn, useNewSignIn = _d === void 0 ? false : _d, setShowSignInModal = _a.setShowSignInModal, signInLinkHref = _a.signInLinkHref, trackingCallback = _a.trackingCallback;
    var _e = useState(false), showAccountMenu = _e[0], setAccountMenuVisibility = _e[1];
    var _f = useState(''), referredUrl = _f[0], setReferredUrl = _f[1];
    var location = useLocation();
    var accountLinks = links.sharedHeader.account;
    useEffect(function () {
        setReferredUrl(location ? location.pathname + location.search : '');
    }, [showAccountMenu, location]);
    var handleOnFocus = function () {
        if (showAccountMenu)
            setAccountMenuVisibility(false);
    };
    var handleCloseSubmenu = function (e) {
        if (e.key === 'Escape' && showAccountMenu)
            setAccountMenuVisibility(false);
    };
    var effectiveSignInLinkHref = useMemo(function () {
        if (signInLinkHref)
            return signInLinkHref;
        var signInSearchParams = new URLSearchParams();
        if (referredUrl) {
            signInSearchParams.set('after-signin-url', referredUrl);
        }
        signInSearchParams.set('authTrigger', 'GLOBAL_NAV');
        return accountLinks.signedOut.url + '?' + signInSearchParams.toString();
    }, [accountLinks.signedOut.url, referredUrl, signInLinkHref]);
    if (!show)
        return null;
    if (isNarrow) {
        return (React.createElement(LoginAction, { isNarrow: isNarrow, userSignedIn: userSignedIn, signedIn: {
                text: accountLinks.signedIn.mobileAccountText,
                url: '/secure/my-auto-trader',
            }, signedOut: {
                text: accountLinks.signedOut.mobileDisplayText,
                url: effectiveSignInLinkHref,
            }, useNewSignIn: useNewSignIn, setShowSignInModal: setShowSignInModal, trackingCallback: trackingCallback }));
    }
    else {
        return (React.createElement(React.Fragment, null,
            !userSignedIn && (React.createElement(React.Fragment, null, !useNewSignIn ? (React.createElement(StyledToolsLink, { as: Link, "$hideOn": "narrow", href: effectiveSignInLinkHref, routerLink: false, "aria-label": "Sign in to your Autotrader Account", trackingCallback: trackingCallback, "data-gui": testIdSignIn, "data-testid": testIdSignIn },
                React.createElement(ActionsIcon, { name: "account" }),
                isNarrow
                    ? accountLinks.signedOut.mobileDisplayText
                    : accountLinks.signedOut.desktopDisplayText)) : (React.createElement(StyledToolsLink, { as: "button", "$hideOn": "narrow", onClick: function () {
                    trackingCallback === null || trackingCallback === void 0 ? void 0 : trackingCallback();
                    if (setShowSignInModal) {
                        setShowSignInModal(true);
                    }
                }, onFocus: handleOnFocus, onKeyDown: handleCloseSubmenu, "data-gui": testIdSignIn, "data-testid": testIdSignIn },
                React.createElement(ActionsIcon, { name: "account" }),
                isNarrow
                    ? accountLinks.signedOut.mobileDisplayText
                    : accountLinks.signedOut.desktopDisplayText)))),
            userSignedIn && (React.createElement(StyledToolsLink, { as: "a", "$hideOn": "narrow", href: accountLinks.signedIn.url, onClick: function () { return trackingCallback === null || trackingCallback === void 0 ? void 0 : trackingCallback(); }, "data-testid": testIdSignOut },
                React.createElement(ActionsIcon, { name: "account" }),
                isNarrow ? accountLinks.signedIn.mobileDisplayText : accountLinks.signedIn.desktopDisplayText))));
    }
};
